import { atom } from 'recoil';

const MENU_STORAGE_KEY = 'menu-state';

const getMenuStateFromStorage = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const stored = sessionStorage.getItem(MENU_STORAGE_KEY);
    return stored ? JSON.parse(stored) : false;
  } catch {
    return false;
  }
};

export const menu = atom({
  key: 'menu',
  default: getMenuStateFromStorage(),
  effects: [
    ({ setSelf, onSet }) => {
      const savedValue = getMenuStateFromStorage();
      if (savedValue !== false) {
        setSelf(savedValue);
      }

      onSet((newValue) => {
        // Defer to avoid blocking main thread during menu toggle
        queueMicrotask(() => {
          try {
            sessionStorage.setItem(MENU_STORAGE_KEY, JSON.stringify(newValue));
          } catch (error) {
            console.error('Error saving menu state to sessionStorage:', error);
          }
        });
      });
    },
  ],
});

export const hideInCharge = atom({
  key: 'hideInCharge',
  default: false,
});

export const showCalendar = atom({
  key: 'showCalendar',
  default: false,
});

// Atom to store fishbone snapshot updates for drag & drop
export const fishboneSnapshotUpdates = atom<Record<string, {
  idPhuongDien?: string | number;
  upperBones: Array<{ id: string; trenDuoi: number; viTri: number }>;
  lowerBones: Array<{ id: string; trenDuoi: number; viTri: number }>;
}>>({
  key: 'fishboneSnapshotUpdates',
  default: {},
});

// Atom to track fishbone instances that need viTri updates due to changes in other fishbones
// Key: instanceId, Value: Set of head IDs that need viTri recalculation
export const fishboneViTriUpdates = atom<Record<string, Set<string>>>({
  key: 'fishboneViTriUpdates',
  default: {},
});